export default angular.module('mobileNavigation', [])
    /**
     * @ngdoc service
     * @name mobileNavigation.service:NavigationService
     * @description
     * Controls a shared environment for navigation elements to
     * communicate with eachother, about what nav is currently open.
     */
    // @ngInject
    .service('NavigationService', function () {
        var activeNavigation = null;
        return {
            setActiveNavigation: function (navigation) {
                activeNavigation = navigation;
                // If there is an active navigation, add
                // a body class to allow fixed scrolling styles
                var has_active_nav = activeNavigation !== null;
                angular.element(document.body)
                    .toggleClass('mobile-navigation--active', has_active_nav);
            },
            isActiveNavigation: function (navigation) {
                return navigation === activeNavigation;
            }
        };
    })
    /**
     * @ngdoc controller
     * @name mobileNavigation.controller:Navigation
     * @description
     * Controls the current state of a mobile navigation
     */
    // @ngInject
    .controller('navigation', function ($scope) {
        $scope.isActive = false;
        $scope.toggle = function (override) {
            return ($scope.isActive = typeof override === 'boolean' ?
                    override : !$scope.isActive);
        };
    })
    /**
     * @ngdoc directive
     * @name mobileNavigation.directive:Navigation
     * @restrict A
     * @description
     * Sets the current state of a navigation item
     */
    // @ngInject
    .directive('navigation', function () {
        return {
            scope: true,
            controller: 'navigation',
            restrict: 'A',
            link: function ($scope, $element) {
                if ($element.hasClass('navigation-item--current')) {
                    $scope.toggle(true);
                }
                $scope.$watch('isActive', function (is_active) {
                    $element.toggleClass('navigation-item--current', is_active);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name mobileNavigation.directive:sharedNavigation
     * @restrict A
     * @description
     * Creates a relationship between unique navigation controllers to
     * ensure only one, at a time, is active.
     */
    // @ngInject
    .directive('sharedNavigation', function (NavigationService) {
        return {
            restrict: 'A',
            link: function ($scope) {
                $scope.$watch('isActive', function (is_active) {
                    if (is_active === true) {
                        NavigationService.setActiveNavigation($scope);
                    }
                    else if (NavigationService.isActiveNavigation($scope)) {
                        NavigationService.setActiveNavigation(null);
                    }
                });
                $scope.$watch(function () {
                    return NavigationService.isActiveNavigation($scope);
                }, function (is_active) {
                    if (!is_active) {
                        $scope.toggle(false);
                    }
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name mobileNavigation.directive:activeNavigation
     * @restrict A
     * @description
     * Sets the default state of a navigation to active
     */
    // @ngInject
    .directive('activeNavigation', function () {
        return {
            restrict: 'A',
            link: function ($scope) {
                $scope.toggle(true);
            }
        };
    })
    /**
     * @ngdoc directive
     * @name mobileNavigation.directive:navigationToggle
     * @restrict A
     * @description
     * Toggles the current state of a navigation item
     */
    // @ngInject
    .directive('navigationToggle', function (AnalyticsService) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                var title = null;
                if ($element.hasClass('sub-navigation-toggle') ||
                        $element.hasClass('secondary-navigation-toggle')) {
                    title = angular.element($element.parent().children()[0]).text();
                }
                else if ($element.hasClass('mobile-site-search-toggle')) {
                    title = $element.children().text();
                }
                $element.on('click touchend', function (e) {
                    e.preventDefault();
                    $scope.$apply(function () {
                        $scope.toggle();
                    });
                    AnalyticsService.trackEvent('Navigation Interaction',
                                                $scope.isActive ? 'Open' : 'Closed',
                                                title);
                });
            }
        };
    });
